import type { ContentType, Distribution } from "./content";
import type { OriginalItemTypes } from "./session";

export type Content = {
	id: string;
	type: ContentType;
	distribution: Distribution;
	totalCount: number;
};

export type DisplayType = ["Filter" | "Progress" | "Display"];
export type Item = {
	id: number;
	type: "flashcard" | "question";
	distribution: keyof Distribution;
	variant?: OriginalItemTypes;
	stats?: {
		score?: number;
		speed?: number;
		accuracy?: number;
	};
};
export interface MixedItemTag {
	id: number;
	title: string;
	code?: string;
	type: string;
	label?: string;
	displayType?: DisplayType;
	iconUrl?: string;
	distribution: Distribution;
	distributionKey?: string;
	locked?: boolean;
	children?: MixedItemTag[];
	weight?: number;
	items?: Item[];
	numItems: number;
	numCorrect?: number;
	numIncorrect?: number;
	score?: number;
	averageScore?: number;
	numTotalPoints?: number;
	numPointsEarned?: number;
	colorScale?: string[];
}

export type LegacyReport = {
	id: string;
	numItems: number;
	numericId: number;
	score: number;
	sessionDate: string;
};

export type ExamStatus =
	| "COMPLETE"
	| "ACTIVE"
	| "NOT_STARTED"
	| "LEGACYREPORT"
	| "MIGRATEDREPORT";

export type ExamSubType = "PRACTICE_TEST" | "DIAGNOSTIC";
export type PracticeTestExam = {
	id: string;
	title: string;
	numItems: number;
	numCompleted: number;
	createdAt: string;
	collectionId: number;
	status?: ExamStatus;
	totalTime: number;
	numericId?: number;
	dateCompleted: string;
	timeElapsed: number;
	distribution: Distribution;
	attempted: Distribution;
	hasAccess?: boolean;
	subType: ExamSubType;
	type?: "SUMMATIVE" | "FORMATIVE";
	legacyReport?: LegacyReport;
	migratedSessionReport?: LegacyReport;
	beginStartDate?: string;
	endStartDate?: string;
	icon?: string;
	numAttemptedItems?: number;
};
export type MixedItemDist = {
	iconUrl: string;
	title: string;
	contents: Content[];
	freeTagIds: number[];
	tags: MixedItemTag[];
	exams?: PracticeTestExam[];
	hasAccess?: boolean;
	accuracy?: number;
};

export type TagsByType = Record<string, MixedItemTag[]>;
